export default {
  appEnv: process.env.REACT_APP_NODE_ENV,
  apiServer: process.env.REACT_APP_API_URL,
  version: process.env.REACT_APP_PACKAGE_VERSION,
};
